import { render } from "./Scenario.vue?vue&type=template&id=545b21a6&scoped=true&ts=true"
import script from "./Scenario.vue?vue&type=script&lang=ts"
export * from "./Scenario.vue?vue&type=script&lang=ts"

import "./Scenario.vue?vue&type=style&index=0&id=545b21a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545b21a6"]])

export default __exports__